import { RefiTermsConditions } from './terms-conditions.component.js';
import { defineRefiElement } from '../../utils/define-refi-element.js';
import '../../lit-element.js';
import '../../class-map.js';
import '../../directive.js';
import '../../styles/reset.style.js';
import '../../styles/links.style.js';

defineRefiElement('refi-common-terms-conditions', RefiTermsConditions);
